import { CompanyName } from 'services/SwaggerApi';

export const mapCompaniesToOptions = (availableCompanies: CompanyName[]) => {
    return availableCompanies.map(({ company_id, name }) => ({
        value: company_id,
        content: name,
    }));
};
